import React from "react";

const FTFRFaq = ({ title, faqs }) => {
  return (
    <section className="ftfr-faq-section">
      <div className="container">
        <h2
          className="text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <div
          className="ftfr-faq-list"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          {faqs.map((faq, i) => (
            <div key={i} className="ftfr-faq-item">
              <p className="ftfr-faq-q">{faq.q}</p>
              <p className="ftfr-faq-a">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FTFRFaq;
